import { render, staticRenderFns } from "./BaseTextarea.vue?vue&type=template&id=19cbb26c&scoped=true&"
import script from "./BaseTextarea.vue?vue&type=script&lang=ts&"
export * from "./BaseTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./BaseTextarea.vue?vue&type=style&index=0&id=19cbb26c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cbb26c",
  null
  
)

export default component.exports